import { Tooltip } from '@hakimo-ui/shared/ui-base';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { ReactNode, Ref } from 'react';
import {
  EditableTimestamp,
  EditableTimestampHandle,
  TIMESTAMP_PILL_SHAPE,
} from '../../shared/EditableTimestamp';
import { useEscalateFills } from './fills';
import { LABEL } from './util';

interface TimestampFieldProps {
  badge: ReactNode;
  timezone?: string;
  readOnly?: boolean;
  timestampRef?: Ref<EditableTimestampHandle>;
  onTouched?: () => void;
}

export function TimestampField({
  badge,
  timezone,
  readOnly = false,
  timestampRef,
  onTouched,
}: TimestampFieldProps) {
  const fills = useEscalateFills();

  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1 pl-6">
      <span className="-ml-6 flex shrink-0 items-center gap-1">
        {badge}
        <span className={`${LABEL} shrink-0 pr-1.5`}>Timestamp</span>
      </span>
      <span className="flex shrink-0 items-center gap-1">
        <EditableTimestamp
          containerClassName={clsx(TIMESTAMP_PILL_SHAPE, fills.control)}
          ref={timestampRef}
          timezone={timezone}
          readOnly={readOnly}
          onFocus={onTouched}
          onDatePickerChange={onTouched ? () => onTouched() : undefined}
        />
        <Tooltip
          text={`TZ - ${timezone ?? 'UTC'}`}
          position="bottom"
          colorModifier="info"
          nowrap
        >
          <InformationCircleIcon className="h-4 w-4 shrink-0 stroke-2" />
        </Tooltip>
      </span>
    </div>
  );
}
